export default host => () => action => ({
  ...action,
  endpoint: action.endpoint.startsWith("http") ? action.endpoint : `${host}${action.endpoint}`,
});
